import { Heading, Button } from '@flixbus/honeycomb-react';
import BatchList from './VoucherList';
import { VoucherBatchesListProvider } from '../../context/VoucherBatchesListProvider';

import styles from './dashboard.module.scss';
import { Icon, IconArrowRight } from '@flixbus/honeycomb-icons-react';

const serviceDeskUrl = 'https://flixtech.atlassian.net/servicedesk/customer/portal/74/group/195';

const BatchesDashboard = () => {
  return (
    <>
      <div className={styles.headerContainer}>
        <Heading size={1} sectionHeader flushSpace>
          My Voucher Batches
        </Heading>
        <Button size='md' Elem='a' href={serviceDeskUrl} target='_blank'>
          Get help or report a problem <Icon InlineIcon={IconArrowRight} />
        </Button>
      </div>
      <VoucherBatchesListProvider>
        <BatchList />
      </VoucherBatchesListProvider>
    </>
  );
};

export default BatchesDashboard;
